import React from 'react';
import { Phone, MapPin, Mail, Facebook, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Description */}
          <div>
            <Logo />
            <p className="text-white/60 text-sm mt-4 leading-relaxed">
              Your trusted local auto repair shop in Worcester, MA. Quality service, honest work, fair pricing.
            </p>
          </div>

          {/* Quick Contact */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <div className="space-y-3">
              <a href="tel:7742425144" className="flex items-center gap-2 text-white/70 hover:text-red-600 transition-colors">
                <Phone size={16} />
                <span>(774) 242-5144</span>
              </a>
              <a href="mailto:kbautorepair715@gmail.com" className="flex items-center gap-2 text-white/70 hover:text-red-600 transition-colors break-all">
                <Mail size={16} />
                <span className="text-sm">kbautorepair715@gmail.com</span>
              </a>
              <div className="flex items-start gap-2 text-white/70">
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <span className="text-sm">522 SW Cutoff, Worcester, MA 01607</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Hours</h3>
            <div className="space-y-2 text-white/70 text-sm">
              <div className="flex justify-between">
                <span>Monday - Friday:</span>
                <span className="text-white">8am - 5pm</span>
              </div>
              <div className="flex justify-between">
                <span>Saturday:</span>
                <span className="text-white">By Appointment</span>
              </div>
              <div className="flex justify-between">
                <span>Sunday:</span>
                <span className="text-white">Closed</span>
              </div>
            </div>

            {/* Social Media (Optional) */}
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-red-600 flex items-center justify-center transition-colors" style={{ borderRadius: '0px' }}>
                <Facebook size={18} className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-red-600 flex items-center justify-center transition-colors" style={{ borderRadius: '0px' }}>
                <Instagram size={18} className="text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} K&B Auto Services Inc. All rights reserved.
          </p>
          <p className="text-white/50 text-sm">
            Proudly serving Worcester, MA and surrounding areas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;